import React from 'react'

const NotificationsTab = () => {
  return (
    <>
    <h5 className='mb-3'>Notification Settings</h5>
    <div className='d-flex align-items-center justify-content-between'>
        <p>Push Notifications</p>
        <span>
        <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault1"/>
            <label className="form-check-label"></label>
        </div>
        </span>
    </div>
    <div className='d-flex align-items-center justify-content-between'>
        <p>Email Notifications</p>
        <span>
        <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault2"/>
            <label className="form-check-label"></label>
        </div>
        </span>
    </div>
    <div className='d-flex align-items-center justify-content-between'>
        <p>Popup Notifications On Desktop</p>
        <span>
        <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault3"/>
            <label className="form-check-label"></label>
        </div>
        </span>
    </div>
    </>
  )
}

export default NotificationsTab